import React from "react";
import { Button } from "reactstrap";
import { FaDollarSign, FaArrowUp, FaArrowDown } from "react-icons/fa";
import { Link } from "react-router-dom";

const BalanceWithdrawButton = ({ balance, onUpdate }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid #8A2BE2",
        borderRadius: "25px",
        padding: "5px 15px",
        backgroundColor: "#000",
        color: "#fff",
        fontWeight: "bold",
        paddingLeft: 7,
        paddingRight: 7
      }}
    >
      <i
        className="fa fa-refresh refresh-icon mr-2 text-primary"
        style={{ cursor: "pointer" }}
        onClick={onUpdate}
      />
      <div style={{ display: "flex", alignItems: "center", marginRight: 4 }}>
        <span style={{ fontSize: "16px" }}>{`R$ ${balance.toFixed(2)}`}</span>
      </div>
      {/**
        <Link
          className="btn btn-primary"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#32b79d",
            border: "none",
            padding: "5px 15px"
          }}
          to="/admin/deposit"
        >
          <FaArrowDown style={{ marginRight: "5px" }} />
          Sacar
        </Link> */}
      <Link
        className="btn btn-primary"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#32b79d",
          border: "none",
          borderRadius: 16,
          padding: "5px 15px"
        }}
        to="/admin/deposit"
      >
        <FaArrowUp style={{ marginRight: "5px" }} />
        Depositar
      </Link>
    </div>
  );
};

export default BalanceWithdrawButton;
